<template>
    <div class="all">
        <!-- 会员导航 -->
        <vipMenu></vipMenu>
        <div class="warp mt20">
            <div class="warp-header">
                <h2>短信购买</h2>
            </div>
            <div class="warp-body clearfix">
                <!-- 建方案 -->
                <div class="form-warp input-list field fl">
                    <div class="item clearfix">
                        <span class="name fl">套餐包规则:</span>
                        <div class="input-father">
                            <div class="corm clearfix">
                                <span class="element" v-for="(item,index) in setMealList" :class="index === noteType - 1 ? 'curr' : ''" @click="selectSetMeal(index);">{{item.smsNum}}条</span>
                            </div>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">购买数量:</span>
                        <div class="input-father duan">
<!--                            <input class="input-text" v-model.trim="number" value="1" maxlength="5" type="text" placeholder="" @keyup="inputNumber();"/>-->
                            <input class="input-text" v-model.trim="number"  type="number"  placeholder=""/>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">应付金额:</span>
                        <div class="input-father duan">
                            <span class="input-tips"><strong class="color-orange fs28">{{prize}}</strong> 清贝</span>
                        </div>
                    </div>
                    <div class="form-btn">
                        <button class="btn save btn-jbblue" @click="payment();">立即支付</button>
                    </div>
                </div>
                <!-- 方案预览 -->
                <div class="examine w300 fl">
                    <div class="examine-header">
                        <h4>短信套餐说明</h4>
                    </div>
                    <div class="examine-body">
                        <ul>
                            <li v-for="(item,index) in explainList"><strong>{{index+1}}.</strong>{{item}}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 充值提示 -->
        <Dialog ref="payModal" :callback="enterPay" type="confirm">
            <div slot="mdBox">
                <p class="ac">确定充值短信</p>
            </div>
        </Dialog>
        <!-- 充值成功提示 -->
        <Dialog ref="sucessModal" type="alert">
            <div slot="mdBox">
                <p class="ac">恭喜充值成功</p>
            </div>
        </Dialog>
	</div>
</template>
<script>
import Dialog from '../../components/dialog.vue';
import vipMenu from './vipMenu.vue';
export default {
    components:{Dialog,vipMenu},
    data() {
        return {
            explainList:'',//短信说明
            setMealList:[],//套餐包规则
            unitPrice:'',//单价
            noteType:'',//类型
            smsNum:'',//短信套餐包单个数量
            number:1,//个数
            prize:''//价格
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.$sensors.track('ClickRecharge', {
                recharge_type:'短信'
            });
            that.getNote();
        })
    },
  watch: {
    number: {
      handler (n, o) {
        let pr=n*this.unitPrice
        this.prize=pr.toFixed(2)
      },
      deep: true// 深度监听父组件传过来对象变化
    },
  },
    created() {

    },
    methods: {
        // 获取短信充值套餐
        getNote () {
            let that = this;
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('user/member/sms-meals',null,r =>{
                that.$parent.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    let data = r.data;
                    that.explainList = data.explainList;
                    that.setMealList = data.list;
                    that.unitPrice = data.list[0].qingBeiNum;
                    that.noteType = data.list[0].mealId;
                    that.smsNum = data.list[0].smsNum;
                    that.countPrize();
                })
            })
        },
        // 套餐包选择
        selectSetMeal (index) {
            let that = this;
            that.noteType = that.setMealList[index].mealId;//短信套餐包id
            that.unitPrice = that.setMealList[index].qingBeiNum;//短信套餐包单价
            that.smsNum = that.setMealList[index].smsNum;//短信套餐包单个数量
            that.countPrize();
        },
        inputNumber () {
            let that = this;
            let number = that.number;
            number = number.replace(/[^\d\.]/g, '');
            let str = number.substr(0,1);
            if(str === '0' || str === '.'){
              number = number.substr(1);
            }
            that.number = number;
            if(number != ''){
                that.number = parseInt(number);
            }
            that.countPrize();
        },
        // 计算价格
        countPrize () {
            let that = this;
            let unitPrice = that.unitPrice;//单价
            let number = that.number;
            let prize = unitPrice*number;//原本总价
            prize = prize.toFixed(2);
            that.prize = prize;
        },
         // 支付
        payment () {
            let that = this;
            let number = that.number;
            let discountPrize = that.discountPrize;
            let qingBeiBalance = that.qingBeiBalance;
            if(number == ''){
                that.$utils.alertText('请输入购买数量');
                return;
            }
            that.$refs.payModal.showMaskFun();
        },
        // 确认充值
        enterPay () {
            let that = this;
            this.$sensors.track('ImmediatePay', {
                recharge_type:'短信',
                pay_number:this.prize
            });
            let datas = {
                mealId:that.noteType,
                num:that.number,
                qingBeiAmount:that.prize
            }
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('user/member/recharge-sms',{data:datas},r =>{
                that.$parent.returnCode(r,function(){
                    that.$sensors.track('PayResult', {
                        recharge_type:'短信',
                        pay_number:that.prize
                    });
                    that.$parent.showLoad = false;
                    let allNum = that.$parent.remainSmsNum;
                    if(allNum != '无限'){
                        that.$parent.remainSmsNum = allNum + (that.number*that.smsNum);
                    }
                    that.$refs.payModal.closeMask();
                    that.$refs.sucessModal.showMaskFun();
                    that.$parent.baseUrl+'/vipRight'
                });
            })
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/duanXinRecharge.vue